import { AxiosArgs, ThenArgs } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeBody } from './client';

type AddTemplatesToAssessment = (a: {
  assessments: string[];
  templates: string[];
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse<unknown>>>>;

export const addTemplatesToAssessment: AddTemplatesToAssessment = (params) => {
  const path = `/api/public/api/assessments/scenarios-from-templates`;
  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(params),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
